module.exports = __webpack_public_path__ + "img/history_2.0c1eb03b.png";